import React from 'react';

import ProfilePack from './component';

export default React.memo(ProfilePack);
